// ==============================|| FECHAS EN PANTALLA ||============================== //
//
// Regla del usuario: toda fecha que se MUESTRA pasa por aquí, en formato
// dd/mm/yyyy; la hora, cuando se muestra, va después (dd/mm/yyyy HH:mm[:ss]).
// El 2026-10-24 se pidió dd-mm-yyyy y el 2026-10-26 se cambió a diagonales
// ("es mejor"), igual que el Excel de obras que arma el API.
// Formato en un solo lugar: el separador vive en SEP.
//
// Acepta lo que manda el API: 'YYYY-MM-DD', 'YYYY-MM-DD HH:MM[:SS]' y ISO con T/Z.
// Una fecha SIN hora se arma de sus partes, sin pasar por Date: así la zona
// horaria no la corre un día. Los <input type="date"> no pasan por aquí (los
// pinta el navegador y su valor es YYYY-MM-DD).

const pad = (n: number) => String(n).padStart(2, '0');
const SEP = '/';

/** Una fecha sin hora ('YYYY-MM-DD'), tal cual, a dd/mm/yyyy. */
const SOLO_DIA = /^(\d{4})-(\d{2})-(\d{2})$/;

function aDate(value: string | Date): Date | null {
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const d = new Date(value.includes('T') ? value : value.replace(' ', 'T'));
  return isNaN(d.getTime()) ? null : d;
}

export interface OpcionesFecha {
  /** Agrega la hora (HH:mm). */
  hora?: boolean;
  /** Con hora, también los segundos. */
  segundos?: boolean;
  /** Qué devolver si no hay fecha. Por omisión '—'. */
  vacio?: string;
}

/**
 * dd/mm/yyyy, o dd/mm/yyyy HH:mm[:ss] con `hora`.
 * Sin valor, o inválido, devuelve `vacio` ('—'); un texto que no es fecha se
 * devuelve tal cual para no esconder el dato.
 */
export function fmtFecha(value: string | Date | null | undefined, opc: OpcionesFecha = {}): string {
  const vacio = opc.vacio ?? '—';
  if (value === null || value === undefined || value === '') return vacio;

  if (typeof value === 'string') {
    const m = SOLO_DIA.exec(value.trim());
    if (m) return `${m[3]}${SEP}${m[2]}${SEP}${m[1]}`;
    // Solo se interpreta lo que empieza como fecha del API: un año suelto
    // ("2026") o un texto lo convertiría Date en otra cosa (01/01/2026).
    if (!/^\d{4}-\d{2}-\d{2}/.test(value.trim())) return value;
  }

  const d = aDate(value);
  if (!d) return typeof value === 'string' ? value : vacio;

  const dia = `${pad(d.getDate())}${SEP}${pad(d.getMonth() + 1)}${SEP}${d.getFullYear()}`;
  if (!opc.hora) return dia;
  return `${dia} ${pad(d.getHours())}:${pad(d.getMinutes())}${opc.segundos ? `:${pad(d.getSeconds())}` : ''}`;
}

/** dd/mm/yyyy HH:mm. */
export const fmtFechaHora = (value: string | Date | null | undefined, vacio = '—') =>
  fmtFecha(value, { hora: true, vacio });

/** dd/mm/yyyy HH:mm:ss (bitácoras). Se conserva el nombre de siempre. */
export function formatDate(value: string | null | undefined): string {
  return fmtFecha(value, { hora: true, segundos: true });
}

/** dd/mm/yyyy (sin hora). Se conserva el nombre de siempre. */
export function formatDateShort(value: string | null | undefined): string {
  return fmtFecha(value ? value.split('T')[0].split(' ')[0] : value);
}
